const jaFormats = {
  number: {
    LOCALE_CURRENCY: {
      style: 'currency',
      currency: 'JPY',
    },
  },
  date: {
    LOCALE_DATE: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
  },
};

export { jaFormats };
